<template>
  <div class="d-flex align-start">
    <v-icon
      class="techStatus mr-2 pa-1"
      color="#fff"
      x-small
      :style="`background-color: ${status.color};`"
    >
      {{ status.icon }}
    </v-icon>
    <div v-if="status.waiting">
      <v-tooltip bottom v-if="isOrdo || status.label === 'DI'">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            {{ displayPlanifDate() }}
          </div>
        </template>
        <span>
          {{ date.hour }}
        </span>
      </v-tooltip>
      <div v-else>
        {{ displayPlanifDate() }}
      </div>
    </div>
    <div v-else-if="status.color">
      {{ status.label }}
    </div>
  </div>
</template>

<script>
import { generatePluralizedMessage, generateMessage } from '@/utils/i18n';

export default {
  name: 'InterventionDate',
  props: {
    date: {
      type: Object,
      required: true,
    },
    status: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isOrdo() {
      return this.status.label === 'Ordonnancée';
    },
  },
  methods: {
    generatePluralizedMessage,
    generateMessage,
    displayPlanifDate() {
      if (typeof this.date.diff === 'number') {
        if (this.date.diff >= 0)
          return this.generatePluralizedMessage(
            'tech_search.fields.event_datetime',
            this.date.diff
          );
        return this.generatePluralizedMessage(
          'tech_search.fields.event_datetime_expired',
          Math.abs(this.date.diff) - 1
        );
      }
      if (this.isOrdo) return this.date.date;
      return (
        this.generateMessage('tech_search.cardView.planif.scheduled') +
        this.date.date
      );
    },
  },
};
</script>

<style scoped>
.techStatus {
  width: max-content;
  border-radius: 50px;
}
</style>
